<template>
  <div class="page">
    <div class="app-container">
      <el-button type="primary" @click="add">新增</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/policy/index"
        :tableData.sync="tableData"
        :columns="columns"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
          <el-button type="text" size="mini" @click="del(row)">删除</el-button>
        </template>
      </BaseTable>

      <el-drawer
        :title="isEdit ? '编辑费用政策' : '新增费用政策'"
        :visible.sync="isShowDrawer"
        direction="rtl"
      >
        <div style="padding: 40px">
          <el-form :model="formData" labelWidth="100px" size="medium">
            <el-form-item label="机构">
              <el-cascader
                v-model="formData.orgId"
                :options="orgOption"
                filterable
                change-on-select
                @change="handleOrgChange"
                :props="{
                  value: 'id',
                  label: 'orgName',
                  emitPath: false,
                }"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="车辆大类">
              <div>
                <el-select
                  style="width: 100%"
                  v-model="formData.carType"
                  placeholder="车辆大类"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in $store.state.app.carBigType"
                    :key="index"
                    :label="item.lable"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="费用政策">
              <el-input v-model="formData.discount" required></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Cost",
  comments: {},
  data() {
    return {
      tableData: [],
      isShowDrawer: false,
      formData: {},
      searchData: {},
      isEdit: false,
      orgOption: [],
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {
    this.getOrg();
	this.$store.dispatch("app/getCarBigType");
  },
  methods: {
    getOrg() {
      this.$api.post("/admin/org/index", {}).then((res) => {
        this.orgOption = res?.data?.data;
      });
    },
    add() {
      this.formData = {};
      this.isShowDrawer = true;
    },

    edit(row) {
      this.formData = {
        id: row.id,
        orgId: row.orgId,
        carType: row.carType,
        discount: row.discount,
      };
      this.isEdit = true;
      this.isShowDrawer = true;
    },

    del(row) {
      this.$confirm("是否确认删除该费用政策信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$api
            .post(
              "/admin/policy/del",
              {
                id: row.id,
              },
              "删除"
            )
            .then(() => {
              this.$refs.baseTable.searchData();
              this.handleSearch();
            });
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: "formData",
            message: "已取消操作",
          });
        });
    },

    onSubmit() {
      this.$api.post("/admin/policy/save", this.formData, "更新").then(() => {
        this.isShowDrawer = false;
        this.$refs.baseTable.searchData();
      });
    },

    handleOrgChange(value) {
      console.log(value);
      if (value.length) {
        this.formData.orgId = value;
      }
    },
    // 点击搜索
    handleSearch() {
      // console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },
  },
};
</script>
